module.exports = __webpack_public_path__ + "img/yao.16a50c7f.png";